import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Identificá',
  description: 'Observá cómo te sentís y reconocé qué necesitás acompañar en este momento.'
}, {
  number: '02',
  title: 'Elegí',
  description: 'Encontrá una práctica o ruta relacionada con lo que estás atravesando.'
}, {
  number: '03',
  title: 'Practicá',
  description: 'Seguí una propuesta breve, clara y posible de adaptar a tu tiempo.'
}, {
  number: '04',
  title: 'Observá',
  description: 'Registrá cómo te sentías antes, cómo te sentís después y qué herramienta querés repetir.'
}];
export function ProductIntro() {
  return <section className="w-full bg-cream px-5 py-12 sm:py-20" data-id="element-227" data-mp="2bllbzwrno1hr">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-228" data-mp="2bk0h261figjd">
        <span className="mb-5 inline-block rounded-full border border-aura/40 bg-aura/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-aura" data-id="element-229" data-mp="udkpglye05ml">
          Conocé Aura Viva 2026
        </span>
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-230" data-mp="147b5d2gg77qo">
          Un sistema visual para transformar lo que sentís en un{' '}
          <span className="text-aura" data-id="element-231" data-mp="1d4lmh4fy5r3i">próximo paso posible</span>
        </h2>

        <div className="mx-auto mt-6 h-px w-16 bg-gold/60" data-id="element-232" data-mp="1861zd0pma99k" />

        <div className="mt-6 space-y-4 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-233" data-mp="1n42o9as2vku7">
          <p data-id="element-234" data-mp="1i59jq7urr466">
            Aura Viva 2026 no es una colección de rituales sueltos ni una rutina rígida que tenés
            que cumplir todos los días.
          </p>
          <p data-id="element-235" data-mp="3ovzapffsaf3r">
            Es un sistema organizado para ayudarte a reconocer qué estás atravesando, encontrar una
            práctica relacionada y comenzar desde el lugar en el que estás hoy.
          </p>
          <p data-id="element-236" data-mp="dhgqt5mf9sp4">
            No necesitás leer todo el material antes de empezar. Tampoco necesitás utilizar todas
            las herramientas al mismo tiempo.
          </p>
          <p data-id="element-237" data-mp="mfalkc4jgea6">Solo abrís el sistema, elegís lo que necesitás y comenzás por una práctica.</p>
        </div>

        <p className="mt-7 font-serif-display text-lg font-bold leading-snug text-plum sm:text-xl" data-id="element-238" data-mp="rgq705amomt3">
          No se trata de hacer más. Se trata de encontrar{' '}
          <span className="text-aura" data-id="element-239" data-mp="10fbjpjtf57ly">qué puede acompañarte ahora</span>.
        </p>
      </motion.div>

      <div className="mx-auto mt-10 grid max-w-5xl gap-4 sm:mt-12 sm:gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-240" data-mp="1561tracshymz">
        {steps.map((step, i) => <motion.article key={step.number} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        delay: i * 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex h-full flex-col rounded-2xl border border-lavender bg-card p-6" data-id="element-241" data-mp="1a4v3qssvb7ie" data-mpi={i}>
            <span className="font-serif-display text-3xl font-bold leading-none text-gold" data-id="element-242" data-mp="2zl77jarft4xo">
              {step.number}
            </span>
            <h3 className="mt-3 text-base font-bold uppercase tracking-wide text-plum sm:text-lg" data-id="element-243" data-mp="2pom1qn7lfpss">
              {step.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-plum/75" data-id="element-244" data-mp="3nbbcblgd3aq9">{step.description}</p>
          </motion.article>)}
      </div>

      <p className="mx-auto mt-10 max-w-2xl text-center font-serif-display text-lg font-bold text-aura sm:text-xl" data-id="element-245" data-mp="3ifcnxxv19spu">
        Identificás. Elegís. Practicás. Observás.
      </p>
    </section>;
}